export default __webpack_public_path__ + "static/Icon2-18bc5c5fcf9043bd662fd0ac6e6d5615.png";